"use server";
import { authOptions } from "@/libs/authOptions";
import { getServerSession } from "next-auth";

const baseUrl = process.env.NEXT_PUBLIC_API_URL;
const requestControllers = new Map<string, AbortController>(); // Mappa per tracciare le richieste attive

export const apiWrapper = async (
    url: string,
    options: RequestInit = {},
    notRequestToken: boolean = false
): Promise<{ success: boolean; data?: any; status?: number; message?: string }> => {
    const session = !notRequestToken ? await getServerSession(authOptions) : null;
    const token =  process.env.NEXT_PUBLIC_BEARER//session?.user?.accessToken;

    const isFormData = options.body instanceof FormData;

    // Annulla eventuale richiesta precedente sulla stessa risorsa
    if (requestControllers.has(url)) {
        requestControllers.get(url)?.abort();
        requestControllers.delete(url);
    }

    const controller = new AbortController();
    requestControllers.set(url, controller);

    const authOptionsObj: RequestInit = {
        ...options,
        headers: {
            ...options.headers,
            ...(isFormData ? {} : { "Content-Type": "application/json" }),
        },
        signal: controller.signal, // Passa il signal di AbortController
    };

    try {
        const response = await fetch(`${baseUrl}/${url}`, authOptionsObj);

        requestControllers.delete(url); // Rimuovi dalla mappa dopo la risposta

        if (!response.ok) {
            let errorMessage = "Errore sconosciuto";
            let details = undefined;
            try {
                const errorResponse = await response.json();
                errorMessage =
                    errorResponse?.data[0].msg || errorResponse?.data[0]?.msg || errorMessage;
                details = errorResponse?.details || errorResponse?.error?.details;
            } catch {
                errorMessage = response.statusText || "Errore sconosciuto";
            }

            console.log({
                url,
                status: response.status,
                message: errorMessage,
                details: details !== undefined ? JSON.stringify(details) : undefined,
            });

            return {
                success: false,
                status: response.status,
                message: errorMessage,
            };
        }

        if (response.status === 204 || response.headers.get("Content-Length") === "0") {
            return { success: true, data: null, status: response.status };
        }

        const data = await response.json();
        return { success: true, data, status: response.status };

    } catch (error: any) {
        requestControllers.delete(url); // Rimuovi dalla mappa in caso di errore

        if (error.name === "AbortError") {
            return {
                success: false,
                status: 499, // Custom status for aborted requests
                message: "Richiesta annullata automaticamente.",
            };
        }

        return {
            success: false,
            status: 500,
            message: "Errore di rete. Riprova più tardi.",
        };
    }
};
